import React, { useState } from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  Box,
  accordionSummaryClasses,
  useTheme,
} from '@mui/material';

import { accordianColors } from '~/components/App/theme';
//import { COLOR_BORDER } from '~/components/App/theme';
import { CrosshairIcon } from '~/components/icons';

interface IConfigurationSection extends Pick<AccordionProps, 'sx'> {
  children: React.ReactNode;
  label: React.ReactNode;
  defaultExpanded?: boolean;
  contenttype?:string;
}

export const AccordionSection = React.memo<IConfigurationSection>(
  function AccordionSection(props) {
    const { children, label, defaultExpanded = false, sx, contenttype } = props;

    const [expanded, setExpanded] = useState<boolean>(defaultExpanded);
    const handleChange = (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded);
    };

    const { palette } = useTheme();

    let margin = '0px';
    let background = accordianColors.bgcolor;
    let color = palette.primary.dark;
    if(contenttype){
      if(contenttype==='trims'){
        margin='0px';
        background = accordianColors.secondlevel;
        color = '#000000';
      }
      else if(contenttype==='colors'){
        //margin='20px';
        background = accordianColors.thirdlevel;
        color = '#000000';
      }
      else if(contenttype==='interiors'){
        //margin='20px';
        background = accordianColors.thirdlevel;
        color = '#000000';
      }
      else if(contenttype==='model'){
        margin='0px';
        background = accordianColors.firstlevel;
        color = '#000000';
      }
    }
    return (
      <Accordion
        disableGutters
        expanded={expanded}
        onChange={handleChange}
        sx={[{
          ml:margin,
          background: 'transparent',
          boxShadow: 0,
          mt: '4px',
          '&:before': {
            background: 'transparent',
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <AccordionSummary
          sx={({ palette }) => ({
            background: background,
            color: color,
            borderRadius: 1,
            fontWeight: 500,
            height: 48,
            [`> div.${accordionSummaryClasses.expanded}`]: {
              my: 1.5,
            },
            '&:first-of-type': {
              borderTop: 0,
            },
          })}
          expandIcon={
            <CrosshairIcon sx={{ fontSize: 16, transform: expanded ? 'rotate(45deg)' : undefined }} />
          }
        >
          {label}
        </AccordionSummary>
        <AccordionDetails sx={{ p: 0, mt: '4px' }}>
          <Box
            sx={{
              borderRadius: 1,
              //border: `1px solid ${COLOR_BORDER}`,
              overflow: 'hidden',
            }}
          >
            {children}
          </Box>
        </AccordionDetails>
      </Accordion>
    );
  }
);
